/**
 * Placeholder for sections whose stories have not landed yet (Contact US-027, FAQ US-019, Provider
 * Update Form US-017). It exists so a tab the acceptance criteria require to be visible never leads to a
 * blank screen.
 *
 * Rendered inside the shell's <main>, so it contributes no landmark of its own.
 */
export function NotAvailableYet(): React.JSX.Element {
  return (
    <section className="mx-auto flex max-w-lg flex-col items-center gap-3 py-16 text-center">
      <h1 className="text-brand-600 text-xl font-semibold">This section is not available yet.</h1>
      <p className="text-muted text-sm">
        It will be enabled in a later release of the Provider Portal.
      </p>
    </section>
  );
}
